export default () => ({
    atletas: [],
    evento: {},
    categoria: {},
    categorias: [],
    clubs: [],
    atletasInscritos: [],
    pendientes: [],
    pago: {},
    dorsales: '',
    disdor: [],
    atletasDistancia: [],
    setmenu: true,
    full: true,
    femenino: [],
    masculino: [],
    caminata: [],
    distancias: [],
    dor: []
})